import { useCancelarTipoObraDialog } from "./use-cancelar-tipo-obra-dialog";
import { CancelarTipoObraDialogView } from "./view-cancelar-tipo-obra-dialog";
import type { CancelarTipoObraDialogProps } from "./types-cancelar-tipo-obra-dialog";

export function CancelarTipoObraDialog(props: CancelarTipoObraDialogProps) {
  const vm = useCancelarTipoObraDialog(props);

  return <CancelarTipoObraDialogView {...vm} />;
}

export type * from "./types-cancelar-tipo-obra-dialog";
